import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

export default function AdventureDepartureDate() {
  const adventureDate = useSelector(({ adventureDate }) => adventureDate)
  const adventureAvailability = useSelector(
    ({ adventureAvailability }) => adventureAvailability,
  )
  const adventureStartTime = adventureAvailability
    ?.find((item) => item.date === adventureDate)
    ?.startTime?.slice(0, -3)
  if(!adventureStartTime || !adventureAvailability.length) {
    return <span>-</span>
  }
  return (
    <span>
      <FormattedMessage
        defaultMessage='{adventureStartTime} departure'
        values={{ adventureStartTime }}
      />
    </span>
  )
}
